/**
 * RelatorioGeracao
 * @author gabrielgil
 */
import {$, ID, Resource} from 'simpli-web-sdk'
import RelatorioGeracaoSchema from '@/schema/RelatorioGeracao.schema'

export default class RelatorioGeracao extends Resource {
  readonly $name: string = 'RelatorioGeracao'

  readonly $endpoint: string = '/user/relatorio-geracao'

  get $id() {
    return this.idRelatorioGeracaoPk
  }
  set $id(val: ID) {
    this.idRelatorioGeracaoPk = val
  }

  get $schema() {
    return RelatorioGeracaoSchema(this)
  }

  idRelatorioGeracaoPk: ID = 0

  idResponsavelFk: ID = 0

  idTipoRelatorioFk: ID = 0

  idFormatoArquivoRelatorioFk: ID = 0

  dataCriacao: string | null = null

  urlDownload: string | null = null

  dataGeracaoRelatorio: string = ''

  dataInicio: string = ''

  dataFim: string = ''

  tipoRelatorioDescricao: string | null = null

  devoExecutarMadrugada: boolean = false
}
